// Must match AVATAR_COLORS in frontend-plg/src/lib/avatar-utils.ts (Tailwind *-600 hex equivalents)
const AVATAR_COLORS = [
  '#9333ea', '#2563eb', '#db2777', '#4f46e5',
  '#0d9488', '#e11d48', '#7c3aed', '#0891b2',
]

export function getAvatarColor(name) {
  let hash = 0
  const str = name || ''
  for (let i = 0; i < str.length; i++) {
    // eslint-disable-next-line no-bitwise
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]
}
